import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { ThemeProvider as CustomThemeProvider, useTheme } from './contexts/ThemeContext';
import { UserDataProvider } from './contexts/UserDataContext';
import { AdminProvider } from './contexts/AdminContext';
import { GlobalStyles } from './styles/GlobalStyles';

// Pages
import HomePage from './pages/HomePage';
import SimulationPage from './pages/SimulationPage';
import ResultsPage from './pages/ResultsPage';
import DashboardPage from './pages/DashboardPage';
import AdminPage from './pages/AdminPage';

// Components
import Header from './components/Header';
import Footer from './components/Footer';

const AppContent: React.FC = () => {
  const { theme } = useTheme();
  
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <UserDataProvider>
        <AdminProvider>
          <Router>
            <div className="App">
              <a href="#main-content" className="skip-link">Przejdź do głównej treści</a>
              <Header />
              <main id="main-content">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/simulation" element={<SimulationPage />} />
                  <Route path="/results" element={<ResultsPage />} />
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/admin" element={<AdminPage />} />
                </Routes>
              </main>
              <Footer />
            </div>
          </Router>
        </AdminProvider>
      </UserDataProvider>
    </ThemeProvider>
  );
};

const App: React.FC = () => {
  return (
    <CustomThemeProvider>
      <AppContent />
    </CustomThemeProvider>
  );
};

export default App;
